import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import getDefaultValues from './getDefaultValues';
import FormField from './FormField';
import Toolbar from './Toolbar';

import { required } from './validate'

const noop = () => {
};

export const SimpleFormBase = (props) => {
  const { toolbar, children, handleSubmit, record, resource, basePath, submitOnEnter, hideSaveButton, ...rest } = props;

  return (
    <form onSubmit={ submitOnEnter ? handleSubmit : noop } className="simple-form">
      <div style={{ padding: '0 1em 1em 1em' }}>
        {React.Children.map(children, input => {
          if (!input)
            return false;
          const validators = input.props.validators || [];
          return (
            <div key={input.props.source} className={`aor-input-${input.props.source}`} style={input.props.style}>
              <FormField
                input={input}
                resource={resource}
                record={record}
                basePath={basePath}
                validate={input.props.isRequired ? [required, ...validators] : [...validators]}
              />
            </div>
          )
        })}
      </div>
      {(!hideSaveButton && toolbar) && (
        React.cloneElement(toolbar, rest)
      )}
    </form>
  );
};

SimpleFormBase.propTypes = {
  children: PropTypes.node,
  defaultValue: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.func,
  ]),
  handleSubmit: PropTypes.func,
  invalid: PropTypes.bool,
  record: PropTypes.object,
  resource: PropTypes.string,
  basePath: PropTypes.string,
  validate: PropTypes.func,
  submitOnEnter: PropTypes.bool,
  toolbar: PropTypes.element,
};

SimpleFormBase.defaultProps = {
  submitOnEnter: true,
  toolbar: <Toolbar/>,
};

const enhanceInit = compose(
  connect((state, props) => ({
    initialValues: getDefaultValues(state, props),
  })),
  reduxForm({
    form: 'record-form',
    enableReinitialize: true,
  }),
);

const enhanceNoInit = compose(
  connect((state, props) => ({
    initialValues: getDefaultValues(state, props),
  })),
  reduxForm({
    form: 'record-form',
  }),
);

export const SimpleForm = enhanceInit(SimpleFormBase);
export const SimpleFormNoInit = enhanceNoInit(SimpleFormBase);



// WEBPACK FOOTER //
// ./src/components/form/SimpleForm.js